import AboutPageShell from '@/components/landing/about-page-shell';
import { Lightbulb, Target } from 'lucide-react';

export default function AboutVisionAndMission() {
    return (
        <AboutPageShell
            title="Vision & Mission"
            description="Read the institutional vision of Northeastern College and the mission statements that guide its service to learners and the community."
        >
            <div className="grid gap-6 md:grid-cols-1">
                <div className="bg-card border-border overflow-hidden rounded-2xl border p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-emerald-500/20 hover:shadow-md md:p-10">
                    <div className="mb-6 flex items-center gap-4">
                        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-emerald-500/10 text-emerald-600 dark:text-[#21d36b]">
                            <Lightbulb className="h-6 w-6" />
                        </div>
                        <h2 className="text-foreground text-lg font-bold md:text-xl">Our Vision</h2>
                    </div>
                    <p className="text-muted-foreground text-sm leading-relaxed md:text-base">
                        Northeastern College is envisioned to stand as one &quot;True Mint of Wisdom&quot; that this part of the region could be proud
                        of.
                    </p>
                </div>

                <div className="bg-card border-border overflow-hidden rounded-2xl border p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-emerald-500/20 hover:shadow-md md:p-10">
                    <div className="mb-6 flex items-center gap-4">
                        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#0A7A35]/10 text-[#0A7A35]">
                            <Target className="h-6 w-6" />
                        </div>
                        <h2 className="text-foreground text-lg font-bold md:text-xl">Our Mission</h2>
                    </div>
                    <ul className="text-muted-foreground space-y-3 text-sm leading-relaxed md:text-base">
                        <li className="flex items-start gap-2">
                            <span className="mt-0.5 font-bold text-[#0A7A35]">•</span>
                            <span>Contribute to the literacy uplift of the valley</span>
                        </li>
                        <li className="flex items-start gap-2">
                            <span className="mt-0.5 font-bold text-[#0A7A35]">•</span>
                            <span>Build up the social, moral, and spiritual values of its educands</span>
                        </li>
                        <li className="flex items-start gap-2">
                            <span className="mt-0.5 font-bold text-[#0A7A35]">•</span>
                            <span>Produce well-prepared individuals for economic responsibilities</span>
                        </li>
                        <li className="flex items-start gap-2">
                            <span className="mt-0.5 font-bold text-[#0A7A35]">•</span>
                            <span>Assist the community in discovering its potentials toward a progressive and peaceful life</span>
                        </li>
                    </ul>
                </div>
            </div>
        </AboutPageShell>
    );
}
